import React,{useContext,useEffect} from 'react';
import { ShowHideSitebar } from '../../../App';
import LeftSitebarMenu from '../../../components/leftSitebarMenu/LeftSitebarMenu';
import MainMenu from '../../../components/mainMenu/MainMenu';
import RightSitebarMenu from '../../../components/rightSitebarMenu/RightSitebarMenu';
import closerIcon from '../../../assets/img/feed-imgs/navbar/closeicon.svg';
import FilterAndShort from '../../../components/filterAndShort/FilterAndShort';
import newDiscussionIcon from '../../../assets/img/forum-imgs/new-discussion-icon.svg'
import ForumDatas from '../forumDatas/ForumDatas';
import ShortMenu from '../../../components/shortMenu/ShortMenu';
import './ForumDetails.css';
import ForumCardDetails from '../forumCardDetails/ForumCardDetails';
import authIcon from '../../../assets/img/blog-imgs/blog-userpic1.svg';
import userOne from '../../../assets/img/feed-imgs/center/story/story-user1.png';
import ForumCardDetailsSecond from '../forumCardDetailsSecond/ForumCardDetailsSecond';
import flexFanLogo from '../../../assets/img/forum-details-imgs/forum-details-flexfan-logo.png';
import shortingIcon from '../../../assets/img/forum-details-imgs/forum-details-sorticon.svg';
import timeIcon from '../../../assets/img/forum-details-imgs/forum-details-timeicon.svg';
import userIcon from '../../../assets/img/forum-details-imgs/forum-details-usericon.svg';
import DateShowCart from '../dateShowCart/DateShowCart';

const ForumDetails = () => {
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'forum';
        setPageName.forum.left = false;
        setPageName.forum.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.forum.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.forum.right = status
            setShowHideSidebar(newStatus)
        }
    }
    return (
        <>
        {/* Main Menu / Main Navbar */}
        <MainMenu></MainMenu>
        {/* Menu bar start here */}
        <div className="container-fluid container-lg">
            <div className="row gap-5 gap-lg-0">
                {/* Left Site Bar Start here */}
                <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.forum?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                     <div className="d-flex d-lg-none justify-content-end mb-3">
                        <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                            <img src={closerIcon} alt="" className='close-menu-button' />
                        </div>
                    </div>
                    <LeftSitebarMenu></LeftSitebarMenu>
                </div>    
                {/* Center Menu */}
                <div className="col-lg-10">
                    <div className="row">
                        <div className="col-lg-6">
                        {/* Add A Forum and Filte section here */}
                        <div className="row my-2">
                            {/* Filter and Short Seciton Component */}
                            <div className="row mb-2 gap-2 gap-lg-0">
                                <div className="col-12 col-lg-8 col-md-6">
                                    <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src={newDiscussionIcon} alt="" className='me-3' />Start New Discussion</button>
                                </div>
                                <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
                                    <FilterAndShort></FilterAndShort>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="col-lg-6">
                        <ShortMenu />
                        </div>
                    </div>
                    <div className="row">
                        <h2 className='curabitur-eget-lacus-mauris'>Curabitur eget lacus mauris.</h2>
                        <div className='shortby'>
                         <img src={userIcon} alt="" />   The London Fella  ·       <img src={timeIcon} alt="" />     Wednesday at 3:17 PM  ·     <img src={shortingIcon} alt="" />  Sort by Reaction Score
                        </div>
                        <div className='created-by'>
                            <span>Created by :</span> <span>  <img src={authIcon} alt="" className='mx-2'/> </span> <span className='awesomeglobal'>Awesomedude20</span>
                            <span>Created on : <span className='awesomeglobal'>Sunday at 11.36 pm</span></span>
                            <span>Replies : <span className='awesomeglobal'>62</span> </span> <span>Views : <span className='awesomeglobal'>125</span> </span> <span>Users : 125</span>
                            <span>Likes : <span className='awesomeglobal'>95</span></span>
                        </div>
                        <div>
                            <div>
                                <p className='forum-details'>Frequent posters ;</p>                             
                            </div>
                            <div>
                                <img src={authIcon} alt="" className='frequent-poster-img'/> <img src={authIcon} alt="" className='frequent-poster-img'/> <img src={authIcon} alt="" className='frequent-poster-img'/> <img src={authIcon} alt="" className='frequent-poster-img'/> <img src={authIcon} alt="" className='frequent-poster-img'/> <img src={authIcon} alt="" className='frequent-poster-img'/> 
                            </div>
                        </div>
                        <div>
                            <p className='images-text my-3'>Images</p>
                           <div className='mb-4'>
                                    <img src={userOne} alt="" className='py-2 me-2' />  <img src={userOne} alt="" className='py-2 me-2' />  <img src={userOne} alt="" className='py-2 me-2' />  <img src={userOne} alt="" className='py-2 me-2' />  <img src={userOne} alt="" className='py-2 me-2' /> 
                           </div>
                        </div>
                    </div>
                    <div className="row">
                        <ForumCardDetails />
                         <div className="col-lg-2">
                            <DateShowCart />
                        </div>
                        <ForumCardDetailsSecond /> 
                       
                    </div>
                    <div className="row">
                       <div className="col-lg-12">
                           <div className='mt-5 py-5'>
                           <img src={flexFanLogo} alt="" className='img-fluid' />    
                           </div>
                       </div>
                    </div>
                </div>
                
            </div>
        </div>
    </>
    );
};

export default ForumDetails;





// import React,{useContext, useEffect} from 'react';
// import LeftSitebarMenu from '../../components/leftSitebarMenu/LeftSitebarMenu';
// import RightSitebarMenu from '../../components/rightSitebarMenu/RightSitebarMenu';
// import MainMenu from './../../components/mainMenu/MainMenu';
// import newDiscussionIcon from '../../assets/img/forum-imgs/new-discussion-icon.svg'
// import FilterAndShort from './../../components/filterAndShort/FilterAndShort';
// import ForumDatas from './forumDatas/ForumDatas';
// import closerIcon from '../../assets/img/feed-imgs/navbar/closeicon.svg';
// import { ShowHideSitebar } from './../../App';
// import forumDetailsDescription from './../components/forumDetailsDescription/forumDetailsDescription';
// const Forum = () => {
//     const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
//     useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
//         const setPageName = {...showHideSidebar}
//         setPageName.pageName = 'forum';
//         setPageName.forum.left = false;
//         setPageName.forum.right = false;
//         setShowHideSidebar(setPageName)
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [])
//     const closeSidebar =(whichSidebar, status)=>{
//         const newStatus = {...showHideSidebar}
//         if(whichSidebar === 'left'){
//             newStatus.forum.left = status /** changing the page name for left sidebar to toggle */
//             setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
//         }
//         if(whichSidebar === 'right'){
//             newStatus.forum.right = status
//             setShowHideSidebar(newStatus)
//         }
//     }
//     return (
//         <>
//             {/* Main Menu / Main Navbar */}
//             <MainMenu></MainMenu>
//             {/* Menu bar start here */}
//             <div className="container-fluid container-lg">
//                 <div className="row gap-5 gap-lg-0">
//                     {/* Left Site Bar Start here */}
//                     <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.forum?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
//                          <div className="d-flex d-lg-none justify-content-end mb-3">
//                             <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
//                                 <img src={closerIcon} alt="" className='close-menu-button' />
//                             </div>
//                         </div>
//                         <LeftSitebarMenu></LeftSitebarMenu>
//                     </div>    
//                     {/* Center Menu */}
//                     <div className="col-lg-6">
//                         {/* Add A Forum and Filte section here */}
//                         <div className="row my-2">
//                             {/* Filter and Short Seciton Component */}
//                             <div className="row mb-2 gap-2 gap-lg-0">
//                                 <div className="col-12 col-lg-8 col-md-6">
//                                     <button className="custm-pill-button-small rounded-pill px-3 py-2 post_btn d-flex align-items-center" type="button"> <img src={newDiscussionIcon} alt="" className='me-3' />Start New Discussion</button>
//                                 </div>
//                                 <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-start gap-4">
//                                     <FilterAndShort></FilterAndShort>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* Forum Details Here */}
//                         <ForumDatas></ForumDatas>
                        
//                      </div>
//                     {/* Right Site Bar Menu */}
//                     <div className={`col-12 col-lg-4  d-lg-block ${showHideSidebar?.forum?.right ? 'd-block right-sitebarmenu' : 'd-none'}`}>
//                         <div className="d-flex d-lg-none justify-content-end mb-3">
//                             <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
//                                 <img src={closerIcon} alt="" className='close-menu-button' />
//                             </div>
//                         </div>
//                         <RightSitebarMenu />
//                     </div>  
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Forum;